var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionIconArrowInput(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon icon_arrow",
    width: "10px",
    height: "7px",
    viewBox: "0 0 10 7",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    id: "ic_action_Arrow"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.000000, -4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99897282,10.4225636 C7.78531992,10.4225636 7.57166702,10.3354589 7.42375348,10.1817932 L3.44652258,6.20291887 C3.11782581,5.88161778 3.11782581,5.36145516 3.44652258,5.04097581 C3.76700193,4.71967473 4.28469934,4.71967473 4.60517869,5.04097581 L7.99897282,8.43805685 L11.4009844,5.04097581 C11.7214637,4.71967473 12.2391611,4.71967473 12.5596405,5.04097581 C12.8801198,5.36145516 12.8801198,5.88161778 12.5596405,6.20291887 L8.58240959,10.1817932 C8.42627862,10.3354589 8.22084314,10.4225636 7.99897282,10.4225636",
    id: "path-arrow",
    fill: "#0079ad",
    fillRule: "nonzero"
  })))));
}
export default __webpack_public_path__ + "static/media/ic-action-icon-arrow-input.c2c00bf9.svg";
export { SvgIcActionIconArrowInput as ReactComponent };